<template>
  <div class="formContainer">
    <!-- <h3>Urlopy</h3>
    <hr />-->
    <div v-if="loaded">
      <b-row no-gutters>
        <b-col md="8">
          <h3>Urlopy</h3>
        </b-col>
        <b-col md="4" class="text-right">
          <b-button variant="primary" @click="onAddEdit()">Dodaj urlop</b-button>
        </b-col>
        <b-col cols="12">
          <hr />
        </b-col>
      </b-row>

      <!-- <b-row no-gutters>
        <b-col cols="12" class="text-right">
          <b-button variant="primary" @click="onAddEdit()">Dodaj urlop</b-button>
        </b-col>
      </b-row>-->
      <b-row no-gutters>
        <b-col cols="12" v-for="freeDay in freeDays" :key="freeDay.id">
          <item :freeDay="freeDay" @delete="onDelete" @edit="onAddEdit(freeDay.id)" />
        </b-col>
      </b-row>
    </div>
    <addEditFreeDayModal ref="addEditModal" @submitted="dataChanged()" :userId="id"></addEditFreeDayModal>
  </div>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";
import item from "./DetailsFreeDayItem";
import addEditFreeDayModal from "./AddEditFreeDayModal";

export default {
  components: { item, addEditFreeDayModal },
  data() {
    return {
      freeDays: [],
      loading: false,
      loaded: false
    };
  },
  mounted() {
    this.loading = true;
    this.getData();
  },
  computed: {},
  props: ["id"],
  methods: {
    onDelete(id) {
      this.$bvModal
        .msgBoxConfirm("Czy na pewno chcesz usunąć ten urlop?")
        .then(answer => {
          if (answer) {
            return axios
              .delete("freeDays", {
                params: {
                  id: id
                }
              })
              .then(() => {
                eventBus.$emit("notify-success", "Usunięto poprawnie.");
                let index = this.freeDays.findIndex(p => p.id === id);
                this.freeDays.splice(index, 1);

                this.$emit("changed");
              })
              .catch(err => {
                eventBus.$emit("unhandled-error", err);
              });
          }
        });
    },
    onAddEdit(id) {
      this.$refs.addEditModal.showModal(id);
    },
    dataChanged() {
      this.getData();
      this.$emit("changed");
    },
    getData() {
      this.loading = true;

      return axios
        .get("/students/freeDays", {
          params: {
            id: this.id
          }
        })
        .then(result => {
          this.freeDays = result.data;
          this.loaded = true;
        })
        .catch(err => {
          eventBus.$emit("unhandled-error", err);
        })
        .then(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  margin-right: 3px;
  margin-bottom: 10px;
}
</style>

